import { render, staticRenderFns } from "./system-kefu.vue?vue&type=template&id=edcfa12c&scoped=true&"
import script from "./system-kefu.vue?vue&type=script&lang=js&"
export * from "./system-kefu.vue?vue&type=script&lang=js&"
import style0 from "./system-kefu.vue?vue&type=style&index=0&id=edcfa12c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcfa12c",
  null
  
)

export default component.exports